export const MENU_DRAWER_WIDTH = 336;

export const RIGHT_DRAWER_WIDTH = 400;
